import { useState } from 'react'

function useTabState() {
  const [currentTab, setCurrentTab] = useState(0)

  function a11yProps(index: any) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }

  return { currentTab, setCurrentTab, a11yProps }
}

export default useTabState
